import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "room_home",
  "use": "room_home-usage",
  "viewBox": "0 0 14 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 12\" id=\"room_home\"><path d=\"M11.93 0H2.07C.93 0 0 .93 0 2.07v5.85c0 1.14.93 2.07 2.07 2.07H6.5v1h-2c-.28 0-.5.22-.5.5s.22.5.5.5h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-2v-1h4.43c1.14 0 2.07-.93 2.07-2.07V2.07C14 .93 13.07 0 11.93 0m0 9H2.07c-.57 0-1.02-.44-1.06-1h11.97c-.03.56-.49 1-1.05 1M13 7H1V2.07C1 1.48 1.48 1 2.07 1h9.85c.59 0 1.07.48 1.07 1.07V7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol